import { useGAPageViews } from '@dx-ui/dx-common';
import { ShowContext, useShowController } from 'react-admin';
import DespatchAdviceShowView from './DespatchAdviceShowView';

const DespatchAdviceShow = (props) => {
  useGAPageViews();
  const controllerProps = useShowController(props);
  return (
    <ShowContext.Provider value={controllerProps}>
      <DespatchAdviceShowView controllerProps={controllerProps} {...props} />
    </ShowContext.Provider>
  );
};

export default DespatchAdviceShow;
